var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"close-on-click-modal":false,"title":_vm.title,"visible":_vm.visible},on:{"close":_vm.onClose,"open":_vm.onOpened}},[_c('div',{staticClass:"form-body"},[_c('table-observation'),_vm._v(" "),_c('div',{staticClass:"col-12 text-center p-t-20"},[_c('el-button',{on:{"click":_vm.onClose}},[_vm._v("Cerrar")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }